import { uid } from "../utils/helpers";

function roundPoint(point: Point): Point {
    var precision = 10;

    var x = parseFloat(point.x.toFixed(precision));
    var y = parseFloat(point.y.toFixed(precision));

    return new Point(x, y);
}

export class Point {
    x: number;
    y: number;
    id: string;
    constructor(x:number, y:number) {
        this.id = uid.rnd();
        this.x = x;
        this.y = y;
    }

    // Common point constants
    static readonly ORIGIN = new Point(0, 0);

    subtract(point: Point): Point {
        return new Point(this.x - point.x, this.y - point.y);
    }

    distanceTo(point: Point): number {
        return Math.hypot(this.x - point.x, this.y - point.y);
    }
    clone(): Point {
        return new Point(this.x, this.y);
    }

    equals(point: Point | null | undefined): boolean {
        if (!point) return false;
        return roundPoint(this).x === roundPoint(point).x && roundPoint(this).y === roundPoint(point).y;
    }
}


